module.exports = __webpack_public_path__ + "img/icon-list.218013be.svg";